<template>
  <div class="ah-search-results">
    <div
      v-for="(category, i) in categories"
      :key="`product-category-${i}`"
    >
      <product-section
        :heading="category.name"
        :categoryId="category.id"
      />
    </div>
  </div>
</template>

<script>
  import ProductSection from '../components/ProductSection.vue'
  
  import { store, getters } from '../data/store'

  export default {
    components: { ProductSection },
    name: 'search-results',
    computed: {
      categories: function() {
        return store.categories
      },
    },
  }
</script>

<style>

</style>
